/**
 * 객체를 받아 URL 쿼리 스트링으로 변환하는 공통 유틸리티 함수
 * @param {Object} params - 쿼리 파라미터 객체
 * @returns {string} 생성된 쿼리 스트링 (예: "size=10&page=1&keyword=test")
 */
export const buildQueryString = (params) => {
  if (!params || typeof params !== 'object') return '';

  return Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => {
      // keyword 등은 인코딩이 필요하므로 안전하게 처리
      // 단, 이미 인코딩된 값일 경우를 대비해 처리할 수도 있으나,
      // 일반적으로 호출부에서 인코딩 없이 넘긴다고 가정.
      return `${key}=${encodeURIComponent(value)}`;
    })
    .join('&');
};

/**
 * 객체를 받아 빈 값(undefined, null, 빈 문자열)을 제거한 페이로드 객체로 반환하는 공통 유틸리티 함수
 * POST 요청 시 body에 들어갈 데이터를 정제할 때 사용합니다.
 * @param {Object} params - 요청 페이로드 객체
 * @returns {Object} 정제된 페이로드 객체
 */
export const buildPayload = (params) => {
  if (!params || typeof params !== 'object') return {};

  return Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
  );
};
